import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	languageContainer: 'js-m-hazardous-substances__list-container',
	languageSelect: 'js-m-hazardous-substances__language-selector',
	stateActive: 'state-m-hazardous-substances__list-container--active',
};

const dataAttr = {
	langCode: 'data-langcode',
};

@createModule('HazardousSubstances')
/**
 * hazardous-substances module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class HazardousSubstances extends TerrificSpec {
	$ctx: JQuery;
	$languageContainer: JQuery;
	$select: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$languageContainer = this.$ctx.find(`.${classes.languageContainer}`);
		this.$select = this.$ctx.find(`.${classes.languageSelect}`);
		this.$select.on('change', this.updateLanguages.bind(this));
		resolve();
	}

	/**
	 * update download button
	 */
	updateLanguages() {
		const langCode = this.getLanguageSelectValue();

		this.$languageContainer.removeClass(classes.stateActive);
		this.$languageContainer.filter(`[${dataAttr.langCode}="${langCode}"]`).addClass(classes.stateActive);

		// reInit InpageNavigation, as height of content changes
		$(window).trigger('NavigationInPage:reInitNoClick');
	}

	/**
	 * Get input select value
	 */
	getLanguageSelectValue(): string {
		return this.$select.val() as string;
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
